import { render, staticRenderFns } from "./step-tech-data-ab.vue?vue&type=template&id=479aefbd"
import script from "./step-tech-data-ab.vue?vue&type=script&lang=ts"
export * from "./step-tech-data-ab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports